import React, { useState, useEffect } from 'react';
import './Profile.css';
import { QrReader } from 'react-qr-reader';
import { useNavigate } from 'react-router-dom';
import en from '../locales/eng.json';
import th from '../locales/th.json';
import CONFIG from '../config';

import { FaArrowRight } from 'react-icons/fa6';

import getProfileImage from '../utils/getProfileImage';

function Profile() {
  const storedData = localStorage.getItem('userData');
  const navigate = useNavigate(); 
  const [showScanner, setShowScanner] = useState(false);
  const [qrResult, setQrResult] = useState(null);
  const [userData, setUserData] = useState(null);
  const [earnedExpiry, setEarnedExpiry] = useState(null);
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'TH';
  });
  const [t, setT] = useState(language === 'EN' ? en : th);

  const profileImage = getProfileImage()
  const middleProfileImage = getProfileImage(true)
  const menuItems = [
    { key: 'my_coupons', img: 'coupon', page: '/my-coupon' },
    { key: 'redeem_points', img: 'reward', page: '/point-redeem' },
    { key: 'my_points', img: 'point', page: '/point-collect' },
    { key: 'purchase_history', img: 'purchase', page: '/purchase-history' },
    { key: 'point_history', img: 'history', page: '/point-history' },
    { key: 'privacy_policy', img: 'policy', page: '/privacy-and-policy' },
    { key: 'term_and_conditions', img: 'term', page: '/term-and-conditions' },
  ]

   useEffect(() => {
    const fetchPointHistory = async () => {
      try {
        const lineUserId = localStorage.getItem('line_user_id');
        if (!lineUserId) return;

        const res = await fetch(
          `${CONFIG.API_BASE_URL}/linepoint/history?line_user_id=${lineUserId}`,
          {
            headers: { accept: 'application/json' }
          }
        );
        const json = await res.json();
        const history = json?.content?.data || [];

        // Filter only entries where status === "Earned"
        const earnedEntries = history.filter((h) => h.status === 'Earned');
        if (earnedEntries.length === 0) {
          setEarnedExpiry(null);
          return;
        }

        // Find the oldest redeemed_at among those “Earned”
        let oldestDate = earnedEntries[0].redeemed_at;
        for (let entry of earnedEntries) {
          if (new Date(entry.redeemed_at) < new Date(oldestDate)) {
            oldestDate = entry.redeemed_at;
          }
        }

        // Compute expiry = oldestDate + 1 year
        const baseDate = new Date(oldestDate);
        const expiryDate = new Date(baseDate);
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);

        setEarnedExpiry(expiryDate);
      } catch (err) {
        console.error('Failed to fetch point history:', err);
        setEarnedExpiry(null);
      }
    };

    fetchPointHistory();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const res = await fetch(`${CONFIG.API_BASE_URL}/lineuser/fetch_user_data?line_user_id=`+ localStorage.getItem('line_user_id'));
        const result = await res.json();

        if (result?.content?.data) {
          setUserData(result.content.data);
        } else {
          throw new Error("Invalid user data format");
        }
      } catch (e) {
        console.error("Failed to fetch user data:", e);
        navigate('/'); // Navigate away if error
      }
    };

    fetchUserData();
  }, [navigate]);

  useEffect(() => {
    localStorage.setItem('language', language); // Save to localStorage
    setT(language === 'EN' ? en : th);          // Set translation
  }, [language]);

  const handleClickMenu = (menuItem) => {
    if (menuItem.page.includes('https')) {
      window.open(menuItem.page, '_blank')
    }
    else {
      navigate(menuItem.page)
    }
  }

  return (
    <div style={{ backgroundColor: ' #FFFFFF'}}>
      <div className="profile-top-section">
        <img onClick={() => navigate('/')} src="/assets/logo-ujoy.png" alt="logo" className="logo-ujoy" />
        <div className="right-section">
          <div className="lang-selector">
            <button
              className={`lang-button ${language === 'TH' ? 'active' : ''}`}
              onClick={() => setLanguage('TH')}
            >
              TH
            </button>
            |
            <button
              className={`lang-button ${language === 'EN' ? 'active' : ''}`}
              onClick={() => setLanguage('EN')}
            >
              EN
            </button>
          </div>
          <div><img onClick={() => navigate('/profile')} src={profileImage} alt="avatar" className="profile-avatar" /></div>
        </div>
      </div>
      <div className="profile-header-bar">
        <button className="back-button" onClick={() => navigate(-1)}>
        <img src="/assets/arrow_back.png" alt="Back" className="back-icon" />
      </button>
        <span className="point-header-title">{t.profile.header}</span>
      </div>

    <div className="main-menu-container">
  {/* Remaining UI (buttons, etc.) */}
      <div>
        <div
        className="points-image-container margin-top"
        onClick={() => navigate('/point-collect')}
      >
        <img
          src={middleProfileImage}
          alt="profile-image"
          className="middle-profile-image"
        />
        <img
          src="/assets/button_point.png"
          alt="point background"
          className="points-image-bg"
        />
        <div className="points-overlay">
          <p className="points-label">{t.mainmenu.points}</p>
          <div className="points-value-row">
            <span className="points-amount">
              {userData?.point?.toLocaleString() || '0'}
            </span>
            <img src="/assets/coin.png" alt="coin" className="coin-icon" />
          </div>
        </div>

              <p className="point-expiry">{userData?.point?.toLocaleString()} {t.mainmenu.points_expiry} {earnedExpiry && (
            <>
               {earnedExpiry.toLocaleDateString()}
            </>
          )}</p>
      </div>
      {
        userData?.expired_point &&
        <p className="profile-point-expiry">{userData?.expired_point} {t.mainmenu.points_expiry}: {userData?.expired_at?.toLocaleString()} </p>
      }
    </div>
    <div
      className="profile-menu-items-wrapper"
    >
      {
        menuItems.map(menuItem => (
          <div
            className="profile-menu-item"
            onClick={() => handleClickMenu(menuItem)}
          >
            <div
              className="profile-menu-item-title"
            >
              <img
                src={`/assets/profile/${menuItem.img}.svg`}
              />
              <span>{t.profile.menu[menuItem.key]}</span>
            </div>
            <FaArrowRight color='#08CCCC' style={{paddingRight: 24}}/>
          </div>
        ))
      }
    </div>
  </div>
</div>

  );
}

export default Profile;
